/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated';
import { createHelpClass } from '../../factoriesAny.js';
export var HelpDependencies = {
  parseDependencies: parseDependencies,
  createHelpClass: createHelpClass
};